<app-user-dashboard [fullScreen]="true">
  <div class="bg-container">
    <div class="container" *ngIf="info">
      <div class="col-12">
        <p-breadcrumb class="max-w-full custom-breadcrumb" [model]="breadcrumbItems" *ngIf="importRequestGuid"></p-breadcrumb>
        <p-breadcrumb class="max-w-full custom-breadcrumb" [model]="breadcrumbItemsES" *ngIf="adsCode && lang == 'es'"></p-breadcrumb>
        <p-breadcrumb class="max-w-full custom-breadcrumb" [model]="breadcrumbItemsEN" *ngIf="adsCode && lang == 'en' "></p-breadcrumb>
      </div>
      <div class="section-top">
        <div class="column-left-top">
          <app-import-request-carousel [offer]="info"></app-import-request-carousel>

          <div class="section-description only-desktop">

            <div class="section-description-info">

              <div class="rowInfo">
                <div class="container-info">
                  <span class="label-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.RequiredProductCertificatesLabel' | translate}}:</span>
                  <section *ngIf="info.importRequest?.productCertificateTypes">
                    <ng-container *ngFor="let productCertificateType of info.importRequest.productCertificateTypes">
                      <p class="data-main-info" *ngIf="!productCertificateType.isOther">{{ productCertificateType.name }}</p>
                      <p class="data-main-info" *ngIf="productCertificateType.isOther">{{ info.importRequest.otherCertificateType }}</p>
                    </ng-container>
                  </section>
                  <span *ngIf="info.importRequest.productCertificateTypes?.length == 0" class="text-info">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
                </div>

                <div class="container-info">
                  <span class="label-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.RequiredPackagingLabel' | translate}}:</span>
                  <section *ngIf="info.importRequest?.packagingTypes">
                    <ng-container *ngFor="let packagingType of info.importRequest.packagingTypes">
                      <p class="data-main-info" *ngIf="!packagingType.isOther">{{ packagingType.name }}</p>
                    </ng-container>
                  </section>
                  <span *ngIf="info.importRequest.packagingTypes?.length == 0" class="text-info">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
                </div>

              </div>

            </div>

          </div>
        </div>

        <div class="column-right-top">
          <div>
            <div class="header-card">
              <div class="section-titles">

                <h2 class="title-product" >
                  {{getHeader()}} / {{getSubheader()}}
                  <!--
                    {{info.importRequest.variety.species.name}} / {{info.importRequest.variety.name}}
                  -->
                </h2>
                <!--
                  <p class="title-price">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.Total' | translate}} {{ totalPrice | currency: 'USD':'US$'}}
                    {{getIncoterms(info.importRequest.typeSale)}}
                  </p>
                -->

                <div class="container-qr only-mobile">
                  <app-qr-image [imageQrData]="imageData" width="50px" height="50px"></app-qr-image>
                </div>

              </div>
              <div class="section-networks">
                <app-social-media-share [url]="urlRoute"></app-social-media-share>
              </div>
            </div>

            <div class="container-countries-qr" >
              <div class="section-countries">

                <div class="container-countries">

                  <div class="container-span">
                    <h5 class="span-info">{{'MarketplacePage.WishList.OriginCountryFieldPlaceholder' | translate}}:</h5>
                    <section class="country-section" *ngIf="info.importRequest">
                      <figure class="figure-country">
                        <img *ngIf="info.importRequest.countryFrom" class="img-country" [flag]="info.importRequest.countryFrom.code" alt=""/>
                        <img *ngIf="!info.importRequest.countryFrom" class="img-country" [flag]="allCountries.code" alt=""/>
                      </figure>
                      <div class="section-country-text">
                        <section *ngIf="info.importRequest.countryFrom">
                          {{info.importRequest.countryFrom.name }}
                        </section>
                        <section *ngIf="!info.importRequest.countryFrom">
                          {{'ImportRequestDetailComponent.OriginCountryAll' | translate}}
                        </section>
                        <section *ngIf="info.importRequest.countryFrom?.locale">
                          {{info.importRequest.countryFrom?.locale }}
                        </section>
                      </div>
                    </section>
                  </div>
                </div>

                <div class="container-countries">
                  <div class="container-span">
                    <h5 class="span-info">{{'MarketplacePage.WishList.DestinationCountryFieldPlaceholder' | translate}}:</h5>
                  </div>
                  <section class="country-section" *ngIf="info.importRequest">
                    <figure class="figure-country">
                      <img class="img-country" [flag]="info.importRequest.country?.code" alt=""/>
                    </figure>
                    <div class="section-country-text">
                      <section>
                        {{info.importRequest.country?.name }}
                      </section>
                      <section *ngIf="info.importRequest.country?.locale">
                        {{info.importRequest.country?.locale }}
                      </section>
                    </div>
                  </section>
                </div>

              </div>
              <div class="container-qr only-desktop">
                <app-qr-image [imageQrData]="imageData" width="100px" height="100px"></app-qr-image>
              </div>
            </div>

            <div class="section-main-info">

              <div class="container-main-info">
                <h5 class="span-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.CasePerPalletsText' | translate}}:</h5>
                <p class="data-main-info">
                  {{info.importRequest.caseQuantityPerPallet }}
                </p>
              </div>

              <div class="container-main-info">
                <h5 class="span-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.PricePerCase' | translate}}:</h5>
                <p class="data-main-info">
                  {{ info.importRequest.pricePerCase | currency:'USD':'US$'}}
                  {{ info.importRequest.pricePerCase ? info.importRequest.typeSale : getNoAvailableLabel() }}
                </p>
              </div>

              <div class="container-main-info">
                <h5 class="span-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.SpeciesSizeText' | translate}}:</h5>
                <p class="data-main-info">
                  <app-text-preview
                    [text]="info.importRequest.speciesSize ? info.importRequest.speciesSize : getNoAvailableLabel()"
                    [maxLength]="30">
                  </app-text-preview>
                </p>
              </div>

              <div class="container-main-info">
                <h5 class="span-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.BoxTypeText' | translate}}:</h5>
                <p class="data-main-info">
                  <app-text-preview
                    [text]="info.importRequest.boxType ? info.importRequest.boxType : getNoAvailableLabel()"
                    [maxLength]="30">
                  </app-text-preview>
                </p>
              </div>

              <div class="container-main-info">
                <h5 class="span-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.PaymentAgainstBLLabel' | translate}}:</h5>
                <p class="data-main-info">
                  {{ info.importRequest.paymentAgainstBL>= 0 ? info.importRequest.paymentAgainstBL + '%' : getNoAvailableLabel() }}
                </p>
              </div>

            </div>

            <div *ngIf="importRequestGuid">
              <h3>{{'MarketplacePage.WishList.ImportRequestModal.CardTitle' | translate}}</h3>
              <div>
                <label>{{'MarketplacePage.WishList.ImportRequestModal.FieldSetLegend' | translate}}</label>
                <section class="section-dropdown-request-detail">
                  <p-dropdown [options]="requestOffers" [(ngModel)]="selectedOffer" placeholder="{{'MarketplacePage.WishList.ImportRequestModal.OfferSelectFieldPlaceholder' | translate}}"
                    optionLabel="name" [filter]="true" filterBy="name" [showClear]="true"
                    [style]="{'minWidth':'100%'}"
                    class="p-inputtext-sm dropdown-input">
                  </p-dropdown>
                  <p-button
                    [style]="{'minWidth':'200px', 'flex':'1', 'width':'100%'}"
                    label="{{'MarketplacePage.WishList.ImportRequestModal.SendButton' | translate}}" (onClick)="sendOfferToRequest()"></p-button>
                </section>
              </div>

              <div *ngIf="selectedOffer" class="col-12">
                <div class="grid">
                  <div class="col-12">
                    <h3>{{'MarketplacePage.WishList.ImportRequestModal.OfferDescription.Title' | translate}}</h3>
                  </div>

                  <div  class="container-info-selected">


                      <div class="container-main-info">
                        <h5 class="span-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.CasePerPalletsText' | translate}}:</h5>
                        <p class="data-main-info">
                          {{selectedOffer.exportOffer.caseQuantityPerPallet }}
                        </p>
                      </div>

                      <div class="container-main-info">
                        <h5 class="span-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.PricePerCase' | translate}}:</h5>
                        <p class="data-main-info">
                          {{ selectedOffer.exportOffer.listPrice | currency:'USD':'US$'}}
                          {{ selectedOffer.exportOffer.listPrice ? info.importRequest.typeSale : getNoAvailableLabel() }}
                        </p>
                      </div>

                      <div class="container-main-info">
                        <h5 class="span-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.SpeciesSizeText' | translate}}:</h5>
                        <p class="data-main-info">
                          <app-text-preview
                          [text]="selectedOffer.exportOffer.speciesSize ? selectedOffer.exportOffer.speciesSize : getNoAvailableLabel()"
                          [maxLength]="30">
                        </app-text-preview>
                        </p>
                      </div>

                      <div class="container-main-info">
                        <h5 class="span-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.BoxTypeText' | translate}}:</h5>
                        <p class="data-main-info">
                          <app-text-preview
                            [text]="selectedOffer.exportOffer.boxType ? selectedOffer.exportOffer.boxType : getNoAvailableLabel() "
                            [maxLength]="30">
                          </app-text-preview>
                        </p>
                      </div>

                      <div class="container-main-info">
                        <h5 class="span-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.PaymentAgainstBLLabel' | translate}}:</h5>
                        <p class="data-main-info">
                          {{ selectedOffer.exportOffer.paymentAgainstBL ? selectedOffer.exportOffer.paymentAgainstBL + '%'  : getNoAvailableLabel() }}
                        </p>
                      </div>


                  </div>

                </div>

              </div>
            </div>

            <div class="flex justify-content-between">
              <!--
                <app-request-import-request [exportOfferGuid]="exportOfferInfo.exportOffer.guid"></app-request-import-request>
                <app-qr-image [imageQrData]="imageData" width="120px" height="120px"></app-qr-image>
              -->
            </div>
            <div class="container-bottom">
              <button pButton (click)="goToLogin()" *ngIf="!profile"
                style="width:300px; margin-bottom:1em"
                label="{{'ExternalMarketPlace.OfferButton' | translate}}"
                ></button>
            </div>
          </div>
        </div>

        <div class="section-description only-mobile">

          <div class="section-description-info">

            <div class="rowInfo">
              <div class="container-info">
                <span class="label-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.RequiredProductCertificatesLabel' | translate}}:</span>
                <section *ngIf="info.importRequest?.productCertificateTypes">
                  <ng-container *ngFor="let productCertificateType of info.importRequest.productCertificateTypes">
                    <p class="data-main-info" *ngIf="!productCertificateType.isOther">{{ productCertificateType.name }}</p>
                    <p class="data-main-info" *ngIf="productCertificateType.isOther">{{ info.importRequest.otherCertificateType }}</p>
                  </ng-container>
                </section>
                <span *ngIf="info.importRequest.productCertificateTypes?.length == 0" class="text-info">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
              </div>

              <div class="container-info">
                <span class="label-info">{{'MarketplacePage.WishList.ImportRequestModal.ImportRequestDescription.RequiredPackagingLabel' | translate}}:</span>
                <section *ngIf="info.importRequest?.packagingTypes">
                  <ng-container *ngFor="let packagingType of info.importRequest.packagingTypes">
                    <p class="data-main-info" *ngIf="!packagingType.isOther">{{ packagingType.name }}</p>
                  </ng-container>
                </section>
                <span *ngIf="info.importRequest.packagingTypes?.length == 0" class="text-info">{{ 'UserPages.UserExportOffers.NotResultsMessages' | translate }}</span>
              </div>

            </div>

          </div>

        </div>
      </div>

    </div>
  </div>
</app-user-dashboard>

<app-footer-home></app-footer-home>
